import type { NavigationMenus, MenuInterface } from './entities';

type MenusExport = NavigationMenus & { globalMenu: MenuInterface[] };

export const menus: MenusExport = {
  globalMenu: [
    {
      href: 'https://www.google.com',
      label: 'Global',
      subnav: {
        action: 'Navigation',
        category: 'Global',
        links: [
          // { href: 'https://www.benzinga.com', img_key: 'USA', label: 'USA', title: 'USA' },
          { href: 'https://es.benzinga.com', img_key: 'ESP', label: 'España', title: 'España' },
          { href: 'https://it.benzinga.com', img_key: 'ITA', label: 'Italia', title: 'Italia' },
          { href: 'https://kr.benzinga.com/', img_key: 'KOR', label: '대한민국', title: '대한민국' },
          { href: 'https://jp.benzinga.com/', img_key: 'JPN', label: '日本', title: '日本' },
          { href: 'https://fr.benzinga.com/', img_key: 'FRA', label: 'Français', title: 'Français' },
        ],
      },
    },
  ],
  primary: [
    {
      href: 'https://www.benzinga.com/services',
      label: 'Premium Services',
      subnav: {
        action: 'Navigation',
        category: 'Premium Services',
        links: [
          {
            href: 'https://www.benzinga.com/premium/ideas/benzinga-edge-4?utm_campaign=premium-services-dropdown&utm_ad_type=navbar',
            label: 'Benzinga Edge',
            premium_service: 'edge',
            title: 'Benzinga Edge',
          },
          {
            href: 'https://www.benzinga.com/pro/pricing?utm_campaign=premium-services-dropdown&utm_ad_type=navbar',
            label: 'Benzinga Pro',
            premium_service: 'pro',
            title: 'Benzinga Pro',
          },
          {
            href: 'https://www.benzinga.com/research/trade-alerts/login?utm_campaign=premium-services-dropdown&utm_ad_type=navbar',
            label: 'Benzinga Research',
            premium_service: 'research',
            title: 'Benzinga Research',
          },
          {
            href: 'https://www.benzinga.com/apis/licensing/user/api-keys?utm_campaign=premium-services-dropdown&utm_ad_type=navbar',
            label: 'Benzinga APIs',
            premium_service: 'apis',
            title: 'Benzinga APIs',
          },
        ],
      },
      width: '108px',
    },
    {
      href: 'https://www.benzinga.com/news',
      label: 'Financial News',
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://www.benzinga.com/news', label: 'Financial News', title: 'Financial News' },
          { href: 'https://www.benzinga.com/news/large-cap', label: 'Large Cap Stocks', title: 'Large Cap Stocks' },
          { href: 'https://www.benzinga.com/news/small-cap', label: 'Small-Cap Stocks', title: 'Small-Cap Stocks' },
          { href: 'https://www.benzinga.com/news/insider-trades', label: 'Insider Trades', title: 'Insider Trades' },
          { href: 'https://www.benzinga.com/earnings', label: 'Earnings', title: 'Earnings' },
          { href: 'https://www.benzinga.com/tech', label: 'Technology', title: 'Technology' },
          { href: 'https://www.benzinga.com/topic/ai', label: 'AI News', title: 'AI News' },
          {
            href: 'https://www.benzinga.com/personal-finance',
            label: 'Personal Finance',
            title: 'Personal Finance',
          },
          { href: 'https://www.benzinga.com/etfs', label: 'ETF News', title: 'ETF News' },
          { href: 'https://www.benzinga.com/crypto', label: 'Crypto News', title: 'Crypto News' },
          { href: 'https://www.benzinga.com/dividends', label: 'Dividend News', title: 'Dividend News' },
          { href: 'https://www.benzinga.com/news/rumors', label: 'Latest Rumors', title: 'Latest Rumors' },
          {
            href: 'https://www.benzinga.com/news/offerings',
            label: 'Latest Offerings News',
            title: 'Latest Offerings News',
          },
        ],
      },
      title: 'All corporate News',
      width: '57px',
    },
    {
      href: 'https://www.benzinga.com/stock-ideas',
      label: 'Investment Ideas',
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://www.benzinga.com/trading-ideas', label: 'Investment Ideas', title: 'Investment Ideas' },
          {
            href: 'https://www.benzinga.com/topic/stock-of-the-day',
            label: 'Stock of the Day',
            title: 'Stock of the Day',
          },
          {
            href: 'https://www.benzinga.com/topic/stock-whisper-index',
            label: 'Stock Whisper Index',
            title: 'Stock Whisper Index',
          },
          {
            href: 'https://www.benzinga.com/analyst-stock-ratings',
            label: 'Analyst Ratings',
            title: 'Analyst Ratings',
          },
          {
            href: 'https://www.benzinga.com/analyst-ratings/analyst-color',
            label: 'Analyst Color',
            title: 'Analyst Color',
          },
          {
            href: 'https://www.benzinga.com/money/best-online-financial-advisors',
            label: 'Financial Advisors',
            title: 'Financial Advisors',
          },
          {
            href: 'https://www.benzinga.com/government-trades',
            label: 'Government Trades',
            title: 'Government Trades',
          },
          { href: 'https://www.benzinga.com/trading-ideas', label: 'Trading Ideas', title: 'Trading Ideas' },
          { href: 'https://www.benzinga.com/screener', label: 'Stock Screener', title: 'Stock Screener' },
        ],
      },
      title: 'Investment Ideas',
      width: '57px',
    },
    {
      href: 'https://www.benzinga.com/markets',
      label: 'Markets',
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://www.benzinga.com/markets', label: 'Markets', title: 'Markets' },
          { href: 'https://www.benzinga.com/premarket', label: 'Premarket Movers', title: 'Premarket Movers' },
          { href: 'https://www.benzinga.com/after-hours-center', label: 'After Hours', title: 'After Hours' },
          { href: 'https://www.benzinga.com/markets/options', label: 'Options', title: 'Options' },
          { href: 'https://www.benzinga.com/etfs', label: 'ETFs', title: 'ETFs' },
          { href: 'https://www.benzinga.com/markets/commodities', label: 'Commodities', title: 'Commodities' },
          {
            href: 'https://www.benzinga.com/prediction-markets',
            label: 'Prediction Markets',
            title: 'Prediction Markets',
          },
          {
            href: 'https://www.benzinga.com/markets/private-markets',
            label: 'Private Markets',
            title: 'Private Markets',
          },
          { href: 'https://www.benzinga.com/markets/bonds', label: 'Bonds', title: 'Bonds' },
          { href: 'https://www.benzinga.com/markets/futures', label: 'Futures', title: 'Futures' },
          { href: 'https://www.benzinga.com/markets/forex', label: 'Forex', title: 'Forex' },
        ],
      },
      width: '75px',
    },
    {
      href: 'https://www.benzinga.com/quote',
      label: 'Top Stocks',
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://www.benzinga.com/quote', label: 'Top Stocks', title: 'Top Stocks' },
          { href: 'https://www.benzinga.com/quote/AAPL', label: 'Apple (AAPL)', title: 'Apple (AAPL)' },
          { href: 'https://www.benzinga.com/quote/TSLA', label: 'Tesla (TSLA)', title: 'Tesla (TSLA)' },
          { href: 'https://www.benzinga.com/quote/AMZN', label: 'Amazon (AMZN)', title: 'Amazon (AMZN)' },
          { href: 'https://www.benzinga.com/quote/NVDA', label: 'Nvidia (NVDA)', title: 'Nvidia (NVDA)' },
          { href: 'https://www.benzinga.com/quote/GOOGL', label: 'Alphabet (GOOGL)', title: 'Alphabet (GOOGL)' },
          {
            href: 'https://www.benzinga.com/quote/META',
            label: 'Meta Platforms (META)',
            title: 'Meta Platforms (META)',
          },
          { href: 'https://www.benzinga.com/quote/MSFT', label: 'Microsoft (MSFT)', title: 'Microsoft (MSFT)' },
          {
            href: 'https://www.benzinga.com/quote/GLD',
            label: 'StreetTracks Gold Shares (GLD)',
            title: 'StreetTracks Gold Shares (GLD)',
          },
          {
            href: 'https://www.benzinga.com/quote/IBIT',
            label: 'IBIT Bitcoin Trust (IBIT)',
            title: 'IBIT Bitcoin Trust (IBIT)',
          },
          {
            href: 'https://www.benzinga.com/screener/top-value-stocks',
            label: 'Top Value Stocks',
            title: 'Top Value Stocks',
          },
          {
            href: 'https://www.benzinga.com/screener/top-momentum-stocks',
            label: 'Top Momentum Stocks',
            title: 'Top Momentum Stocks',
          },
          {
            href: 'https://www.benzinga.com/screener/top-growth-stocks',
            label: 'Top Growth Stocks',
            title: 'Top Growth Stocks',
          },
          {
            href: 'https://www.benzinga.com/screener/top-quality-stocks',
            label: 'Top Quality Stocks',
            title: 'Top Quality Stocks',
          },
        ],
      },
      width: '90px',
    },
    {
      href: 'https://www.benzinga.com/money',
      label: 'Learn',
      subnav: {
        action: 'Navigation',
        category: 'Toolbar',
        links: [
          { href: 'https://www.benzinga.com/money', label: 'Learn', title: 'Learn' },
          {
            href: 'https://www.benzinga.com/money/investing',
            label: 'Investing Guides',
            title: 'Investing Guides',
          },
          {
            href: 'https://www.benzinga.com/money/personal-finance',
            label: 'Personal Finance',
            title: 'Personal Finance',
          },
          { href: 'https://www.benzinga.com/money/mortgages', label: 'Mortgages', title: 'Mortgages' },
          {
            href: 'https://www.benzinga.com/money/best-credit-cards',
            label: 'Best Credit Cards',
            title: 'Best Credit Cards',
          },
          {
            href: 'https://www.benzinga.com/money/best-dividend-paying-stocks',
            label: 'Best Dividend Stocks',
            title: 'Best Dividend Stocks',
          },
          {
            href: 'https://www.benzinga.com/money/best-swing-trade-stocks',
            label: 'Best Swing Trade Stocks',
            title: 'Best Swing Trade Stocks',
          },
        ],
      },
      width: '57px',
    },
    // {
    //   href: 'https://www.benzinga.com/watch',
    //   label: 'TV',
    //   subnav: {
    //     action: 'Navigation',
    //     category: 'Toolbar',
    //     links: [
    //       { href: 'https://www.benzinga.com/watch', label: 'Watch', title: 'Watch' },
    //       { href: 'https://www.youtube.com/benzinga', label: 'YouTube', title: 'YouTube' },
    //       { href: 'https://www.benzinga.com/podcasts', label: 'Podcasts', title: 'Podcasts' },
    //     ],
    //   },
    // },
    // {
    //   href: 'https://careers.benzinga.com/?source=navbar',
    //   label: 'Jobs',
    // },
    // {
    //   href: 'https://www.benzinga.com/courses/trading-school?utm_source=topnav&utm_medium=topnav',
    //   label: 'Trading School',
    // },
  ],
  secondary: [
    {
      href: 'https://www.benzinga.com/research',
      label: 'Research',
      width: '110px',
    },
    {
      href: 'https://www.benzinga.com/login?action=register&next=https://www.benzinga.com/profile/portfolio',
      label: 'My Stocks',
      logged_in_href: 'https://www.benzinga.com/profile/portfolio',
      width: '105px',
    },
    {
      groups: [
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Calendars',
          links: [
            {
              href: 'https://www.benzinga.com/analyst-stock-ratings',
              label: 'Analyst Ratings Calendar',
              title: 'Analyst Ratings Calendar',
            },
            {
              href: 'https://www.benzinga.com/calendars/conference-calls',
              label: 'Conference Call Calendar',
              title: 'Conference Call Calendar',
            },
            {
              href: 'https://www.benzinga.com/dividends',
              label: 'Dividend Calendar',
              title: 'Dividend Calendar',
            },
            {
              href: 'https://www.benzinga.com/earnings',
              label: 'Earnings Calendar',
              title: 'Earnings Calendar',
            },
            {
              href: 'https://www.benzinga.com/calendars/economic',
              label: 'Economic Calendar',
              title: 'Economic Calendar',
            },
            {
              href: 'https://www.benzinga.com/calendars/events',
              label: 'Events Calendar',
              title: 'Events Calendar',
            },
            { href: 'https://www.benzinga.com/fda-calendar', label: 'FDA Calendar', title: 'FDA Calendar' },
            {
              href: 'https://www.benzinga.com/calendars/guidance',
              label: 'Guidance Calendar',
              title: 'Guidance Calendar',
            },
            { href: 'https://www.benzinga.com/calendars/ipos', label: 'IPO Calendar', title: 'IPO Calendar' },
            { href: 'https://www.benzinga.com/calendars/m-a', label: 'M&A Calendar', title: 'M&A Calendar' },
            {
              href: 'https://www.benzinga.com/calendars/options',
              label: 'Unusual Options Activity Calendar',
              title: 'Unusual Options Activity Calendar',
            },
            { href: 'https://www.benzinga.com/calendars/spac', label: 'SPAC Calendar', title: 'SPAC Calendar' },
            {
              href: 'https://www.benzinga.com/calendars/stock-splits',
              label: 'Stock Split Calendar',
              title: 'Stock Split Calendar',
            },
          ],
        },
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Trade Ideas',
          links: [
            { href: '/reports', label: 'Stock Reports', title: 'Stock Reports' },
            { href: 'https://www.benzinga.com/sec/insider-trades/', label: 'Insider Trades', title: 'Insider Trades' },
            { href: 'https://www.benzinga.com/trading-ideas', label: 'Trade Idea Feed', title: 'Trade Idea Feed' },
            {
              href: 'https://www.benzinga.com/analyst-stock-ratings',
              label: 'Analyst Ratings',
              title: 'Analyst Ratings',
            },
            {
              href: 'https://www.benzinga.com/calendars/unusual-options-activity',
              label: 'Unusual Options Activity',
              title: 'Unusual Options Activity',
            },
            { href: 'https://www.benzinga.com/tools/heatmap', label: 'Heatmaps', title: 'Heatmaps' },
            { href: 'https://www.benzinga.com/free-newsletters', label: 'Free Newsletter', title: 'Free Newsletter' },
            {
              href: 'https://www.benzinga.com/government-trades',
              label: 'Government Trades',
              title: 'Government Trades',
            },
            {
              href: 'https://www.benzinga.com/portfolio/perfect-stock-portfolio',
              label: 'Perfect Stock Portfolio',
              title: 'Perfect Stock Portfolio',
            },
            {
              href: 'https://www.benzinga.com/portfolio/easy-income-portfolio',
              label: 'Easy Income Portfolio',
              title: 'Easy Income Portfolio',
            },
          ],
        },
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Short Interest',
          links: [
            {
              href: 'https://www.benzinga.com/short-interest/most-shorted',
              label: 'Most Shorted',
              title: 'Most Shorted',
            },
            {
              href: 'https://www.benzinga.com/short-interest/largest-increase',
              label: 'Largest Increase',
              title: 'Largest Increase',
            },
            {
              href: 'https://www.benzinga.com/short-interest/largest-decrease',
              label: 'Largest Decrease',
              title: 'Largest Decrease',
            },
          ],
        },
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Calculators',
          links: [
            {
              href: 'https://www.benzinga.com/tools/options-profit-calculator',
              label: 'Options Profit Calculator',
              title: 'Options Profit Calculator',
            },
            {
              href: 'https://www.benzinga.com/margin-calculator',
              label: 'Margin Calculator',
              title: 'Margin Calculator',
            },
            {
              href: 'https://www.benzinga.com/forex-profit-calculator',
              label: 'Forex Profit Calculator',
              title: 'Forex Profit Calculator',
            },
            {
              href: 'https://www.benzinga.com/tools/100x-options-profit-calculator',
              label: '100x Options Profit Calculator',
              title: '100x Options Profit Calculator',
            },
            {
              href: 'https://www.benzinga.com/tools/covered-call-calculator',
              label: 'Covered Call Calculator',
              title: 'Covered Call Calculator',
            },
            {
              href: 'https://www.benzinga.com/tools/cash-secured-put-calculator',
              label: 'Cash-Secured Put Calculator',
              title: 'Cash-Secured Put Calculator',
            },
            {
              href: 'https://www.benzinga.com/tools/long-call-calculator',
              label: 'Long Call Calculator',
              title: 'Long Call Calculator',
            },
            {
              href: 'https://www.benzinga.com/tools/long-put-calculator',
              label: 'Long Put Calculator',
              title: 'Long Put Calculator',
            },
          ],
        },
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Screeners',
          links: [
            {
              href: 'https://www.benzinga.com/screener',
              label: 'Stock Screener',
              title: 'Stock Screener',
            },
            {
              href: 'https://www.benzinga.com/screener/top-momentum-stocks',
              label: 'Top Momentum Stocks',
              title: 'Top Momentum Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/top-quality-stocks',
              label: 'Top Quality Stocks',
              title: 'Top Quality Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/top-value-stocks',
              label: 'Top Value Stocks',
              title: 'Top Value Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/top-growth-stocks',
              label: 'Top Growth Stocks',
              title: 'Top Growth Stocks',
            },
          ],
        },
        {
          action: 'Navigation',
          category: 'Toolbar',
          label: 'Compare Best Stocks',
          links: [
            {
              href: 'https://www.benzinga.com/screener/best-momentum-stocks',
              label: 'Best Momentum Stocks',
              title: 'Best Momentum Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/best-quality-stocks',
              label: 'Best Quality Stocks',
              title: 'Best Quality Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/best-value-stocks',
              label: 'Best Value Stocks',
              title: 'Best Value Stocks',
            },
            {
              href: 'https://www.benzinga.com/screener/best-growth-stocks',
              label: 'Best Growth Stocks',
              title: 'Best Growth Stocks',
            },
          ],
        },
      ],
      href: 'https://www.benzinga.com/tools',
      label: 'Tools',
      marked: true,
      width: '100px',
    },
  ],
};
